import { T2CStatus } from '../constants/payments';
export const getMultiApproverValues = (t2cMulitpleApproverContacts, multipleApproversEnabled, t2cStatus) => {
    const pendingT2CAuthContacts = (t2cMulitpleApproverContacts || []).filter((contact) => contact.status === T2CStatus.PENDING);
    const enrolledT2CAuthContacts = (t2cMulitpleApproverContacts || []).filter((contact) => contact.status === T2CStatus.ENROLLED);
    const pendingT2CAuthPhoneNumbers = pendingT2CAuthContacts.map((contact) => contact.t2cNumber);
    const numberOfPendingT2CAuthContacts = pendingT2CAuthContacts.length;
    const numberOfT2CAuthContacts = (t2cMulitpleApproverContacts || []).length;
    const numberOfEnrolledT2CAuthContacts = enrolledT2CAuthContacts.length;
    const isT2CAuthorized = (t2cStatus === null || t2cStatus === void 0 ? void 0 : t2cStatus.toLowerCase()) === 'enrolled';
    const isT2CPending = (t2cStatus === null || t2cStatus === void 0 ? void 0 : t2cStatus.toLowerCase()) === 'pending';
    const showT2CMultiPendingAlert = (isT2CAuthorized || isT2CPending) &&
        multipleApproversEnabled &&
        numberOfT2CAuthContacts > 0 &&
        numberOfPendingT2CAuthContacts > 0;
    return {
        pendingT2CAuthPhoneNumbers,
        numberOfPendingT2CAuthContacts,
        numberOfT2CAuthContacts,
        showT2CMultiPendingAlert,
        numberOfEnrolledT2CAuthContacts,
        isT2CAuthorized,
        isT2CPending,
    };
};
